import { render, staticRenderFns } from "./CustomJpgOrder.vue?vue&type=template&id=5be8c934&scoped=true&"
import script from "./CustomJpgOrder.vue?vue&type=script&lang=js&"
export * from "./CustomJpgOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomJpgOrder.vue?vue&type=style&index=0&id=5be8c934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8c934",
  null
  
)

export default component.exports